import { z } from 'zod';

export const BootstrapAdminBodySchema = z.object({
  email: z.email(),
  fullName: z.string().min(1),
});

export type BootstrapAdminBody = z.infer<typeof BootstrapAdminBodySchema>;

export const InviteBootstrapAdminResponseSchema = z.object({
  inviteId: z.uuid(),
});

export type InviteBootstrapAdminResponse = z.infer<typeof InviteBootstrapAdminResponseSchema>;

export const AcceptLocalBootstrapAdminResponseSchema = z.object({
  inviteId: z.uuid(),
  userId: z.uuid(),
});

export type AcceptLocalBootstrapAdminResponse = z.infer<
  typeof AcceptLocalBootstrapAdminResponseSchema
>;

export const ProvisioningStatusResponseSchema = z.object({
  organizationId: z.uuid(),
  bootstrapInvite: z.object({
    status: z.enum(['NONE', 'PENDING', 'ACCEPTED', 'EXPIRED']),
    email: z.email().nullable(),
    expiresAt: z.iso.datetime().nullable(),
  }),
  profileTemplatesCloned: z.boolean(),
});

export type ProvisioningStatusResponse = z.infer<typeof ProvisioningStatusResponseSchema>;
